import React, { useState, useCallback, useMemo } from 'react';
import { Collection, Button } from '@components/common';
import { useLanguage } from '@contexts/LanguageContext';
import { useNotification } from '@hooks/useNotification';
import { useLocationCreationPermission } from '@hooks/useLocationPermissions';
import Modal from '@components/common/Modal';
import LocationForm from './LocationForm';
import Icon from '@components/Icon/Icon';
import api from '@services/api';
import './LocationsPage.scss';

const LocationsPage = () => {
  const { t } = useLanguage();
  const notify = useNotification();
  const [showFormModal, setShowFormModal] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const { canCreate: canCreateLocation } = useLocationCreationPermission();

  const handleCreateLocation = async (locationData) => {
    try {
      await api.post('/locations', locationData);
      setShowFormModal(false);
      setRefreshTrigger(prev => prev + 1);
      notify.success(t('locationsAdmin.createSuccess'));
    } catch (err) {
      console.error(t('locationsAdmin.createError'), err);
      notify.error(t('locationsAdmin.createError'));
      throw err;
    }
  };

  const openCreateModal = useCallback(() => {
    setShowFormModal(true);
  }, []);

  const closeFormModal = useCallback(() => {
    setShowFormModal(false);
  }, []);


  return (
    <div className="locations-page">
      <Collection
        modelName="locations"
        displayType="list"
        title={t('locations.title')}
        description={t('locations.subtitle')}
        className="locations-collection"
        refreshTrigger={refreshTrigger}
        enableSearch={true}
        enablePagination={true}
        onRefresh={() => setRefreshTrigger(prev => prev + 1)}
      />

      <Modal
        isOpen={showFormModal}
        onClose={closeFormModal}
        title={t('locationsAdmin.createLocation')}
        className="location-form-modal"
      >
        <LocationForm
          location={null}
          onSubmit={handleCreateLocation}
          onCancel={closeFormModal}
        />
      </Modal>
    </div>
  );
};

export default LocationsPage;
